import { Component } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { DivisionSalesNetworkService } from '../../../services/division-sales-network/divison-sales-network.service';
import { StoreCommonService } from '../../../services/store/store-common.service';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCardService } from '../../../services/loyalty/loyalty-card.service';
import { Card, CardDomiciliationModel } from '../../../models/loyalty-card.model';

@Component({
  selector: 'kv-loyalty-domiciliation-massive-store',
  template: `
      <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_dsn_from', md: '6'}">
              <p-dropdown [options]="divisionSaleNetworkItemsFrom"
                          (onChange)="onDivisionSalesNetworkFromChange($event)"
                          [style]="{ 'width': '100%'}"
              >
              </p-dropdown>
          </div>
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_store_from', md: '6'}">
              <p-dropdown [options]="storeItemsFrom"
                          [style]="{ 'width': '100%'}"
                          (onChange)="onStoreFromSelected($event)"
              >
              </p-dropdown>
          </div>


          <div *ngIf="cardDomiciliationStore != null">
              <div class="ui-g-12">
                  <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_massive_store_total', md: '4'}">
                  </div>
                  <div class="ui-g-8" style="text-align: center;">
                      <label style="{width:100%;}" style="text-align: center;" >{{cardDomiciliationStore.length}}</label>
                  </div>
              </div>
              <div [kv-form-element]="{ label: 'loyalty.domiciliation_dsn_to', md: '6'}">
                  <p-dropdown [options]="divisionSaleNetworkItemsTo"
                              (onChange)="onDivisionSalesNetworkToChange($event)"
                              [style]="{ 'width': '100%'}"
                  >
                  </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: 'loyalty.domiciliation_store_to', md: '6'}">
                  <p-dropdown [options]="storeItemsTo"
                              [style]="{ 'width': '100%'}"
                              [(ngModel)]="destinationStore"
                  >
                  </p-dropdown>
              </div>

              <div class="ui-g-12">
                  <div class="ui-g-4"></div>
                  <div class="ui-g-4">
                      <button pButton type="button" class="buttonExpand k-generic-btn" icon="fa fa-search" iconPos="left" [label]="'loyalty.domiciliation_massive_range_perform' | translate" (click)="performDomiciliation()" ></button>
                  </div>
                  <div class="ui-g-4"></div>
              </div>
          </div>


      </div>
  `
})
export class LoyaltyDomiciliationMassiveStoreComponent {
  divisionSaleNetworkItemsFrom: SelectItem[] = [];
  storeItemsFrom: SelectItem[] = [];

  divisionSaleNetworkItemsTo: SelectItem[] = [];
  storeItemsTo: SelectItem[] = [];

  translations: any;

  cardDomiciliationStore: Card[] = null;
  destinationStore: any;



  constructor(
    private svcDivisionSalesNetwork: DivisionSalesNetworkService,
    private svcStores: StoreCommonService,
    private translate: TranslateService,
    private svcCard: LoyaltyCardService,
    private notification: MessageService
  ) {

    this.translate.get([
      'common.select',
      'loyalty.domiciliation_massive_ok_summary',
      'loyalty.domiciliation_massive_ok_detail'
    ]).subscribe(t => {
      this.translations = t;
    })

    this.svcDivisionSalesNetwork.getListExpanded().subscribe(dsn_list => {
      this.divisionSaleNetworkItemsFrom = [{
        value: null,
        label: this.translations['common.select']
      }]

      this.divisionSaleNetworkItemsTo = [{
        value: null,
        label: this.translations['common.select']
      }]

      this.storeItemsTo = [{
        value: null,
        label: this.translations['common.select']
      }]

      this.storeItemsFrom = [{
        value: null,
        label: this.translations['common.select']
      }]

      dsn_list.forEach(dsn => {
        this.divisionSaleNetworkItemsFrom.push({
          value: dsn.id,
          label: dsn.division_name + " - " + dsn.sales_network_name
        })

        this.divisionSaleNetworkItemsTo.push({
          value: dsn.id,
          label: dsn.division_name + " - " + dsn.sales_network_name
        })
      })
    })



  }

  onDivisionSalesNetworkFromChange(data) {
    this.cardDomiciliationStore = null;
    this.onDivisionSalesNetworkChange('storeItemsFrom', data)

  }

  onDivisionSalesNetworkToChange(data) {
    this.onDivisionSalesNetworkChange('storeItemsTo', data)

  }

  onDivisionSalesNetworkChange(storeItemList: string, data) {
    const dsnId = data.value;
    this.svcStores.getList(null, null, {
      division_sales_network: dsnId
    }).subscribe(stores => {
      this[storeItemList] = [ {
        value: null,
        label: this.translations['common.select']
      }]
      stores.forEach(s => {
        this[storeItemList].push({
          value: s.id,
          label: s.code + " - " + s.name
        })
      })
    })

  }

  onStoreFromSelected(data) {
    const storeId = data.value;
    let params = Array<{ key: string, value: string }>();
    params.push({
      key: 'storeId',
      value: storeId
    })
    this.svcCard.list(null, null, params).subscribe(items => {
      this.cardDomiciliationStore = items.data
    })

  }

  performDomiciliation() {
    let domiciliations : CardDomiciliationModel[] = [];
    this.cardDomiciliationStore.forEach(card => {
      domiciliations.push({
        store_from: parseInt(card.store_id),
        card_id: parseInt(card.id),
        store_to: this.destinationStore
      })
    })

    this.svcCard.massiveDomiciliate(domiciliations).subscribe(res => {
      this.notification.add({severity:'success', summary: this.translations['loyalty.domiciliation_massive_ok_summary'], detail: this.translations['loyalty.domiciliation_massive_ok_detail'] + ": " + res})
    })


  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation-massive-store.component.ts